import React, { Suspense, lazy, useContext } from 'react';

import {
  BrowserRouter as Router,
  Switch,
  Redirect,
  Route,
} from 'react-router-dom';

import { Preloader } from 'nbds-react';

import { AuthContext } from 'contexts/authentication/AuthContext';
import ProtectedRoute from 'contexts/authentication/PrivateRoute';

const Login = lazy(() => import('pages/login/Login'));
const Member = lazy(() => import('pages/member/Member'));
const NotFound = lazy(() => import('pages/not-found/NotFound'));

function AppRoutes() {
  const { isAuthenticated } = useContext(AuthContext);

  return (
    <main className="app-main">
      <Router>
        <Suspense fallback={<Preloader message="Loading Content..." />}>
          <Switch>
            <Route path="/" exact>
              {isAuthenticated ? <Redirect to="/member" /> : <Login />}
            </Route>
            <ProtectedRoute path="/member" component={Member} />
            <Route path="*" component={NotFound} />
          </Switch>
        </Suspense>
      </Router>
    </main>
  );
}

export default AppRoutes;
